<!-- @format -->

<h3 class="ui primary header">
  {{ modal.context.isEdit ? "Edit" : "Add" }} Individual
  <i class="link times icon" (click)="modal.deny(undefined)"></i>
</h3>

<app-warning-label></app-warning-label>
<div *ngIf="success || error" tamsyMargin marginY="10px">
  <esl-message-toast [(message)]="error"></esl-message-toast>
  <esl-message-toast
    [(message)]="success"
    [messageType]="'success'"
  ></esl-message-toast>
</div>

<div
  class="content ui basic segment"
  [ngClass]="{ loading: pending }"
  appPadding
  paddingB="30"
>
  <div class="scroll-wrapper ui basic segment">
    <div class="ui form" [formGroup]="companyDirectorForm">
      <div *ngIf="modal.context.data.item === 'SHAREHOLDER_STRUCTURE'">
        <div
          style="
            font-weight: 600;
            font-size: 16px;
            line-height: 19px;
            color: #3f4395;
          "
        >
          Shareholder Type
        </div>
        <div class="ui divider"></div>
        <div style="margin-bottom: 30px">
          <div class="grouped fields">
            <div class="field" style="margin-bottom: 10px">
              <input
                type="radio"
                name="example"
                value="Individual"
                formControlName="example"
                [(ngModel)]="typeId"
                (ngModelChange)="onTypeChange($event)"
              />&nbsp;&nbsp;Individual
            </div>
            <div class="field">
              <input
                type="radio"
                name="example"
                value="Company Representative"
                formControlName="example"
                [(ngModel)]="typeId"
                (ngModelChange)="onTypeChange($event)"
              />&nbsp;&nbsp;Company
            </div>
          </div>
        </div>
      </div>
      <div
        *ngIf="typeId === 'Company Representative'"
        class="required field"
        [ngClass]="displayFieldCss('companyName')"
      >
        <label>Company Name</label>
        <input
          #input
          formControlName="companyName"
          type="text"
          placeholder="Company Name"
        />
        <app-field-error-display
          [displayError]="isFieldValid('companyName')"
          errorMsg="Please enter  Company Name"
        >
        </app-field-error-display>
      </div>
      <div
        *ngIf="typeId === 'Company Representative'"
        class="required field"
        [ngClass]="displayFieldCss('companyRegNumber')"
      >
        <label>Company Registration Number</label>
        <input
          #input
          formControlName="companyRegNumber"
          type="text"
          placeholder="Company Registration Number"
        />
        <app-field-error-display
          [displayError]="isFieldValid('companyRegNumber')"
          errorMsg="Please enter Company Registration Number"
        >
        </app-field-error-display>
      </div>
      <div
        *ngIf="typeId === 'Company Representative'"
        class="required field"
        [ngClass]="displayFieldCss('shareholding')"
      >
        <label>Percentage of Shareholding Amount</label>
        <input
          formControlName="shareholding"
          type="number"
          appRestrictToGreaterThanZero
          placeholder="Shareholding Amount"
        />
        <app-field-error-display
          [displayError]="isFieldValid('shareholding')"
          errorMsg="Please enter shareholding Amount"
        >
        </app-field-error-display>
      </div>
      <div
        style="
          font-weight: 600;
          font-size: 16px;
          line-height: 19px;
          color: #3f4395;
        "
      >
        {{ typeId }}'s Information
      </div>
      <div class="ui divider"></div>
      <div>
        <div fxLayout="row">
          <div fxFlex>
            <div fxFlex>
              <div *ngIf="companyDirector?.photographDocumentId">
                <div class="required field">
                  <label>PROFILE PHOTO</label>
                </div>
                <div style="display: flex; align-items: center">
                  <img
                    src="assets/avatar/1.jpg"
                    class="ui circular tiny image"
                  />
                  <label style="padding-left: 15px">
                    {{ fileNamePhoto ? fileNamePhoto : "Upload profile photo" }}
                  </label>
                </div>
                <input
                  formControlName="document"
                  type="file"
                  accept=".jpg, .jpeg, .png"
                  #uploader
                  (change)="onFileChangeData($event)"
                  placeholder="Browse for documents"
                  onclick="value = null"
                  style="display: none"
                />
                <div
                  class="ui button"
                  (click)="uploader.click()"
                  style="
                    background-color: #eaeffb;
                    border-radius: 8px;
                    margin-top: 20px;
                  "
                >
                  Browse
                </div>
              </div>

              <div *ngIf="!companyDirector?.photographDocumentId">
                <div class="required field">
                  <label>PROFILE PHOTO</label>
                </div>
                <div style="display: flex; align-items: center">
                  <img
                    src="assets/avatar/1.jpg"
                    class="ui circular tiny image"
                  />
                  <p style="padding-left: 15px">
                    {{ fileNamePhoto ? fileNamePhoto : "Upload profile photo" }}
                  </p>
                </div>

                <input
                  formControlName="document"
                  type="file"
                  accept=".jpg, .jpeg, .png, .JPG, .JPEG"
                  #uploader
                  (change)="onFileChangeData($event)"
                  placeholder="Browse for documents"
                  onclick="value = null"
                  style="display: none"
                />
                <div
                  class="ui button"
                  (click)="uploader.click()"
                  style="
                    background-color: #eaeffb;
                    border-radius: 8px;
                    margin-top: 20px;
                  "
                >
                  Browse
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="required field" [ngClass]="displayFieldCss('firstName')">
        <label>First Name</label>
        <input
          #input
          formControlName="firstName"
          type="text"
          placeholder="Firstname"
        />
        <app-field-error-display
          [displayError]="isFieldValid('firstName')"
          errorMsg="Please enter  FirstName"
        >
        </app-field-error-display>
      </div>

      <div class="required field" [ngClass]="displayFieldCss('lastName')">
        <label>Last Name</label>
        <input formControlName="lastName" type="text" placeholder="LastName" />
        <app-field-error-display
          [displayError]="isFieldValid('lastName')"
          errorMsg="Please enter  LastName"
        >
        </app-field-error-display>
      </div>

      <div class="field" [ngClass]="displayFieldCss('middleName')">
        <label>Middlename</label>
        <input
          formControlName="middleName"
          type="text"
          placeholder="MiddleName"
        />
        <app-field-error-display
          [displayError]="isFieldValid('middleName')"
          errorMsg="Please enter Middle Name"
        >
        </app-field-error-display>
      </div>

      <div class="required field" [ngClass]="displayFieldCss('gender')">
        <label>Gender</label>
        <select formControlName="gender" class="ui search dropdown">
          <option value="">Select Gender</option>
          <option value="male">Male</option>
          <option value="female">Female</option>
        </select>
        <app-field-error-display
          [displayError]="isFieldValid('gender')"
          errorMsg="Please select your Gender"
        >
        </app-field-error-display>
      </div>

      <div class="required field" [ngClass]="displayFieldCss('nationalityId')">
        <label>Nationality</label>
        <select class="ui search dropdown" formControlName="nationalityId">
          <option
            *ngFor="let country of countries"
            value="{{ country?.countryCode }}"
          >
            {{ country?.countryName }}
          </option>
        </select>
        <app-field-error-display
          [displayError]="isFieldValid('nationalityId')"
          errorMsg="Please select your Nationality"
        >
        </app-field-error-display>
      </div>

      <div
        class="required field"
        [ngClass]="displayFieldCss('countryOfOriginId')"
      >
        <label>Country of Origin</label>
        <select formControlName="countryOfOriginId" class="ui search dropdown">
          <option
            *ngFor="let country of countries"
            value="{{ country?.countryCode }}"
          >
            {{ country?.countryName }}
          </option>
        </select>
        <app-field-error-display
          [displayError]="isFieldValid('countryOfOriginId')"
          errorMsg="Please select your Country of Origin"
        >
        </app-field-error-display>
      </div>

      <div
        class="required field"
        [ngClass]="displayFieldCss('nationalIdNumber')"
      >
        <label>National ID Number</label>
        <input
          formControlName="nationalIdNumber"
          type="text"
          placeholder="National ID Number"
        />
        <app-field-error-display
          [displayError]="isFieldValid('nationalIdNumber')"
          errorMsg="Please Enter National ID Number"
        >
        </app-field-error-display>
      </div>

      <div class="required field" [ngClass]="displayFieldCss('address')">
        <label>Address</label>
        <input formControlName="address" type="text" placeholder="Address" />
        <app-field-error-display
          [displayError]="isFieldValid('address')"
          errorMsg="Please enter address"
        >
        </app-field-error-display>
      </div>

      <div class="required field" [ngClass]="displayFieldCss('email')">
        <label>Email</label>
        <input formControlName="email" type="email" placeholder="Email" />
        <app-field-error-display
          [displayError]="isFieldValid('email')"
          errorMsg="Please enter a valid email"
        >
        </app-field-error-display>
      </div>

      <div class="required field" [ngClass]="displayFieldCss('phoneNumber')">
        <label>Phone Number</label>
        <input
          formControlName="phoneNumber"
          type="text"
          placeholder="Phone Number"
        />
        <app-field-error-display
          [displayError]="isFieldValid('phoneNumber')"
          errorMsg="Please enter 11 digit phone number"
        >
        </app-field-error-display>
      </div>

      <div class="required field" [ngClass]="{ error: affiliateTypeInvalid() }">
        <label>Select Affiliate Type</label>
        <div class="ui segment affiliateTypes">
          <div
            *ngFor="let affiliateType of companyAffiliateTypes"
            class="ui checkbox"
          >
            <input
              type="checkbox"
              [value]="affiliateType?.ownershipTypeId"
              (change)="affiliateTypeChanged($event)"
              [checked]="
                existingPersonnel?.organizationOwnershipTypeId ==
                affiliateType?.ownershipTypeId
              "
              [disabled]="existingPersonnel?.organizationOwnershipTypeId"
            />
            <label for="">{{ affiliateType?.ownershipType | titlecase }}</label>
          </div>
        </div>
        <app-field-error-display
          [displayError]="affiliateTypeInvalid()"
          errorMsg="Select at least one affiliate type"
        >
        </app-field-error-display>
      </div>

      <!-- *ngIf="modal.context.data.item == 'SHAREHOLDER_STRUCTURE'" -->
      <div
        class="required field"
        *ngIf="
          (existingPersonnel?.organizationOwnershipTypeId ==
            'shareholder_type' ||
            checkShareholderTypeSelected()) &&
          typeId === 'Individual'
        "
        [ngClass]="displayFieldCss('shareholding')"
      >
        <label>Percentage of Shareholding Amount</label>
        <input
          formControlName="shareholding"
          type="number"
          appRestrictToGreaterThanZero
          placeholder="Shareholding Amount"
        />
        <app-field-error-display
          [displayError]="isFieldValid('shareholding')"
          errorMsg="Please enter shareholding Amount"
        >
        </app-field-error-display>
      </div>
      <div appMargin marginB="7"></div>
    </div>
    <form
      class="ui form"
      *ngIf="uploads.length > 0"
      appMargin
      style="margin-bottom: 30px; flex-direction: column"
    >
      <h2 class="ui head" fxFlex="auto">Upload Supporting Document</h2>
      <p>
        Click the plus (+) button to upload new document. You can link any
        similar document you have uploaded before now by choosing the Link
        option. Only .pdf, .doc and .ppt files can be uploaded
      </p>
      <div>
        <div
          *ngFor="let document of documentss; let i = index"
          style="margin-bottom: 20px"
        >
          <div fxLayout="row" style="width: 100%">
            <label fxFlex="auto" [ngClass]="{ required: document.isRequired }">
              Upload {{ document.documentTypeName }}
            </label>
            <div suiDropdown>
              <button
                class="ui tiny icon button"
                style="border: none !important; align-items: center !important"
                style="float: right"
              >
                <i
                  class="ui plus icon hoverable"
                  suiPopup
                  [popupInverted]="true"
                  popupPlacement="bottom"
                  popupText="upload Document"
                ></i>
              </button>
              <div
                class="menu"
                style="margin-top: 20px"
                suiDropdownMenu
                appPadding
                paddingX="3"
              >
                <div
                  class="item"
                  style="
                    padding: 16px 0px;
                    color: #3f4395;
                    font-size: 14px;
                    font-weight: 500;
                    cursor: pointer;
                  "
                  (click)="uploader.click()"
                >
                  <input
                    #uploadDoc
                    type="file"
                    accept=".pdf,.doc,.docx,.odf:not(.zip),.xls,.xlsx"
                    #uploader
                    multiple
                    (change)="onFileChanges($event, document)"
                    placeholder="Browse for documents"
                    onclick="value = null"
                    style="display: none"
                  />
                  Upload new document
                </div>
                <a
                  class="item"
                  style="
                    padding: 16px 0px;
                    color: #3f4395;
                    font-size: 14px;
                    font-weight: 500;
                    cursor: pointer;
                  "
                  (click)="LinkDocument(document.documentTypeName)"
                  >Link an existing document</a
                >
              </div>
            </div>
          </div>
          <div
            style="width: 100%"
            class="ui divider"
            appMargin
            marginT="1"
          ></div>
          <div
            *ngIf="
              returnDocumentType(
                allLinkedDocuments,
                document.documentTypeName,
                document.documentTypeId
              ).length > 0
            "
            style="width: 100%"
            class="field"
            appMargin
            marginT="5px"
          >
            <div
              class="item"
              style="
                padding: 16px 0px;
                color: #3f4395;
                font-size: 14px;
                font-weight: 500;
              "
            >
              Linked existing documents of {{ document.documentTypeName }}
            </div>
            <ng-container class="document">
              <div
                *ngFor="
                  let doc of returnDocumentType(
                    allLinkedDocuments,
                    document.documentTypeName,
                    document.documentTypeId
                  );
                  let i = index
                "
              >
                <div
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    height: 64px;
                    border-top: 1px solid #dfdfdf;
                    width: 100%;
                  "
                >
                  <div style="display: flex; align-items: center">
                    <img
                      src="../../../../../assets/icons/pdfdoc.svg"
                      alt="data"
                    />
                    <p
                      style="
                        margin-left: 20px;
                        font-style: normal;
                        font-weight: 400;
                        font-size: 14px;
                        line-height: 16px;
                        color: #505050;
                      "
                    >
                      {{
                        doc.documentName
                      }}
                    </p>
                  </div>
                  <div>
                    <div
                      style="
                        align-items: center !important;
                        gap: 8px;
                        display: flex;
                        justify-content: flex-end;
                      "
                    >
                      <a
                        href="{{ baseUrl }}/public/media/?media={{
                          doc.documentPath
                        }}"
                        target="_blank"
                      >
                        <i class="eye icon"></i>
                      </a>
                      <div
                        class="ui button"
                        style="background-color: #eaeffb; border-radius: 8px"
                        (click)="
                          editLinkedDocument(doc, i, document.documentTypeName)
                        "
                      >
                        Edit
                      </div>
                      <img
                        class="hoverable"
                        src="assets/icons/cancel.svg"
                        (click)="removeLinkedDocument(doc, i)"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
          <div style="width: 100%" class="field" appMargin marginT="5px">
            <ng-container
              *ngIf="
                document.uploadedFiles && document.uploadedFiles.length > 0
              "
            >
              <ng-container
                *ngFor="
                  let file of document.uploadedFiles;
                  let fileIndex = index
                "
              >
                <div
                  fxLayout="row"
                  fxLayoutGap="10px"
                  fxLayoutAlign="start center"
                  appMargin
                  marginB="15px"
                >
                  <div
                    fxFlex="grow"
                    class="ui segment"
                    style="border-radius: 8px"
                  >
                    <div
                      fxFlex="row"
                      fxLayoutGap="10px"
                      fxLayoutAlign="start center"
                    >
                      <div fxFlex="10">
                        <img
                          src="assets/icons/file-type/doc-upload.svg"
                          alt=""
                        />
                      </div>
                      <div fxFlex="75">
                        <div>
                          {{ file.name }}
                        </div>
                      </div>
                      <div fxFlex fxLayoutAlign="end">
                        <div
                          class="ui button"
                          style="background-color: #eaeffb; border-radius: 8px"
                          (click)="uploaderEdit.click()"
                        >
                          <input
                            #uploadDoc
                            type="file"
                            accept=".pdf,.doc,.docx,.odf:not(.zip),.xls,.xlsx"
                            #uploaderEdit
                            multiple
                            (change)="editFile($event, document, fileIndex)"
                            placeholder="Edit document"
                            onclick="value = null"
                            style="display: none"
                          />
                          Edit
                        </div>
                        <img
                          class="hoverable"
                          src="assets/icons/cancel.svg"
                          (click)="removeFile(document, fileIndex)"
                        />
                      </div>
                    </div>
                  </div>
                </div> </ng-container
            ></ng-container>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>

<div class="actions" style="background: inherit; border: none">
  <button class="ui basic primary button" (click)="modal.deny(undefined)">
    Back
  </button>
  <button
    class="ui primary button"
    [ngClass]="{ yellow: pending }"
    [disabled]="
      pending ||
      !companyDirectorForm.valid ||
      affiliateTypeInvalid2() ||
      uploadSupportingFilesInvalid()
    "
    (click)="submit()"
    autofocus
  >
    {{ modal.context.isEdit ? "Update" : "Add" }}
  </button>
</div>
